module.exports = __webpack_public_path__ + "static/fonts/ionicons.05acfdb.woff";


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/styles/common/iconfont/fonts/ionicons.woff?v=2.0.0
// module id = 761
// module chunks = 34